import React from "react";

const CustomCellModal = ({ props, gallery, videos }) => {
  console.log("props", props);

  return (
    <div className="flex flex-col font-poppins text-dark-green gap-y-2 items-center justify-center w-full">
      <h1 className="font-bold text-lg ">{props.title}</h1>
      <div className="flex  flex-wrap items-center justify-center w-full">
        {props.field == "supplies" &&
          props.data &&
          props.data.map((supplie, j) => {
            return (
              <li
                key={j}
                className="flex flex-row gap-x-2 py-1 items-center text-default-gray m-0"
              >
                <input
                  type="checkbox"
                  disabled={true}
                  checked={true}
                  className="m-0 rounded-[2px] checked:bg-simple-gray focus:ring-transparent"
                />

                {supplie.sName}
              </li>
            );
          })}
        {props.field == "images" &&
          props.data.length > 0 &&
          props.data.map((img, i) => {
            return (
              <div
                className="flex flex-col max-w-[150px] m-2 rounded-xl shadow-md"
                key={i}
              >
                <img
                  src={`${process.env.REACT_APP_SERVER}${img.url}`}
                  className="rounded-t-xl"
                />
                <span className="py-1 px-2">{img.alt}</span>
              </div>
            );
          })}
        {props.field == "videos" &&
          videos.map((video, i) => {
            return (
              <div
                className="flex flex-col max-w-[300px] m-2 rounded-xl shadow-md"
                key={i}
              >
                <iframe
                  style={{
                    borderTopRightRadius: "15px",
                    borderTopLeftRadius: "15px",
                    width: "300px",
                    maxWidth: "300px",
                    //height: "220px",
                    aspectRatio: "3/1.8",
                    margin: "0px !important",
                  }}
                  src={video.url}
                  frameBorder="0"
                  allowFullScreen
                  ng-show="showvideo"
                ></iframe>
                <span className="py-1 px-2">
                  {video.title.slice(0, 30) + "..."}
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default CustomCellModal;
